import { computed } from '@vue/composition-api'
import { getUserData } from '@/auth/utils'

// Plain (non-reactive) check — for imperative guards inside update()/delete() before a
// mutation runs, where a computed ref would be overkill (single read, not bound to a template).
export const hasPermission = (module, action) => !!getUserData()?.permissions?.[module]?.[action]?.allowed

export const permissionScope = (module, action) => getUserData()?.permissions?.[module]?.[action]?.scope || null

// Reactive version — for conditioning buttons/actions in templates with v-if. Tracks
// userData.permissions from the Vuex store (userStore.userData), fusionado en Login.vue
// desde permission_default (+ overrides por worker, más adelante).
export default function usePermission(module, action) {
  const entry = computed(() => getUserData()?.permissions?.[module]?.[action] || null)

  const allowed = computed(() => !!entry.value?.allowed)
  const scope = computed(() => entry.value?.scope || null)

  return { allowed, scope }
}
